import {
  Component,
  DoCheck,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AdminApi, Emoji, EmojiApi, LoopBackConfig } from "@lbsdk/*";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { SortablejsOptions } from "angular-sortablejs";
import { ConfirmationDialogComponent } from "@app/main/content/confirmation-dialog/confirmation-dialog.component";
import { environment } from "@env/environment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GeneralSettingsService } from "@app/main/content/general-settings/general-settings.service";
import { MatDialog } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as _ from "lodash";
import { E } from "@angular/core/src/render3";

@Component({
  selector: "default-emojis",
  templateUrl: "./default-emojis.component.html",
  styleUrls: ["./default-emojis.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DefaultEmojisComponent implements OnInit, OnChanges, DoCheck {
  @Input("defaultEmojis") defaultEmojis: Emoji[];
  defaultEmojisOptions: SortablejsOptions = {
    group: "normal-group",
  };
  fileNameDialogRef: any;

  deletedEmojis: any[] = [];

  s3BucketUrl: string = environment.s3BucketUrl;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private adminApi: AdminApi,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private emojiApi: EmojiApi,
    private http: HttpClient,
    private generalSettingsService: GeneralSettingsService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  //////////////////////
  // Life Cycle Hooks//
  ////////////////////

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.defaultEmojis = changes.defaultEmojis.currentValue;
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  ngDoCheck(): void {
    // screen1 check
    if (this.defaultEmojis.length >= 48) {
      this.defaultEmojisOptions = {
        group: {
          name: "normal-group",
          put: false,
          pull: true,
        },
      };
    } else {
      this.defaultEmojisOptions = {
        group: {
          name: "normal-group",
          put: true,
          pull: true,
        },
      };
    }
  }

  /////////////////////
  // Public Methods //
  ///////////////////

  uploadEmoji = async ($event) => {
    this.fuseSplashScreenService.show();
    let emoji;
    const emojis = [];
    const files: any[] = $event.target.files;
    const noOfEmojis = this.defaultEmojis.length + files.length;
    if (files.length && noOfEmojis <= 48) {
      for (let i = 0; i < files.length; i++) {
        const file = $event.target.files[i];
        const formData = new FormData();
        formData.append("file", file);

        const headers = new HttpHeaders();
        headers.append("Content-type", "multipart/form-data");
        headers.append("Accept", "application/json");

        const params = {
          access_token: this.adminApi.getCurrentToken().id,
        };

        const url: string =
          LoopBackConfig.getPath() +
          "/" +
          LoopBackConfig.getApiVersion() +
          "/containers/" +
          encodeURIComponent(this.generalSettingsService.emojiUploadPath) +
          "/upload";

        try {
          let response: any = await this.http
            .post(url, formData, { headers: headers, params: params })
            .toPromise();
          if (!response) continue;
          emoji = response.result.files["file"][0]["providerResponse"].name;
          if (this.deletedEmojis.length !== 0) {
            emojis.push({
              id: this.deletedEmojis[i].id,
              image: emoji,
              emojiType: "default",
              isActive: true,
              order: this.deletedEmojis[i].order,
            });
          } else {
            emojis.push({
              image: emoji,
              emojiType: "default",
              isActive: true,
              order: i + 1,
            });
          }
        } catch (error) {
          console.log("error....", error);
        }
      }

      if (this.deletedEmojis.length !== 0) this.deletedEmojis = [];

      for (let emoji of emojis) {
        try {
          let response = await this.emojiApi.patchOrCreate(emoji).toPromise();
          if (!response) continue;
          this.snackBar.open("Emoji added", "OK", {
            verticalPosition: "top",
            duration: 2000,
          });
        } catch (error) {
          console.log("error....", error);
        }
      }
      let defaultEmojis: any[] = await this.emojiApi
        .find({
          where: {
            and: [{ isActive: true }, { emojiType: "default" }],
          },
          order: "order ASC",
        })
        .toPromise();
      if (!defaultEmojis && defaultEmojis.length === 0) return;
      this.defaultEmojis = defaultEmojis;
      this.fuseSplashScreenService.hide();
    } else {
      this.snackBar.open("Emojis exceeds the allowable limit", "OK", {
        verticalPosition: "top",
        duration: 4000,
      });
      this.fuseSplashScreenService.hide();
    }
  };

  defaultEmojiDelete(emoji) {
    this.fileNameDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: "Are you sure you want to Delete?",
      },
    });
    this.fileNameDialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(async (result) => {
        if (!result) return;
        this.fuseSplashScreenService.show();
        emoji.isActive = false;
        emoji.image = emoji.image.replace(environment.s3BucketUrl, "");

        this.deletedEmojis.push(emoji);
        this.deletedEmojis = [..._.orderBy(this.deletedEmojis, ["order"])];

        try {
          let response = await this.emojiApi
            .patchAttributes(emoji.id, emoji)
            .toPromise();
          if (!response) return;
        } catch (error) {
          console.log("error...", error);
          return error;
        }

        try {
          let getDefaultEmojis: any = await this.emojiApi
            .find({
              where: {
                and: [{ isActive: true }, { emojiType: "default" }],
              },
              order: "order ASC",
            })
            .toPromise();
          this.fuseSplashScreenService.hide();
          if (!getDefaultEmojis) return;

          this.defaultEmojis = [];
          this.defaultEmojis = getDefaultEmojis;
        } catch (error) {
          this.fuseSplashScreenService.hide();
          console.log("error....", error);
          return error;
        }
      });
  }
}
